import { IUserAccountStore } from '../index'
import { IToggleLimitModal } from '../../../actions/userAccount/limit/toggleLimitModal'

export default function(
  store: IUserAccountStore,
  action: IToggleLimitModal,
): IUserAccountStore {
  return {
    ...store,
    limitModal: {
      ...store.limitModal,
      open: action.toggle,
    },
  }
}
